import domtoimage from 'dom-to-image';

const saveAs = (uri, filename) => {
    let link = document.createElement('a');
    if (typeof link.download === 'string') {
        link.href = uri;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        window.open(uri);
    }
}

export const take_screenshot = (node, file_name) => {
    domtoimage
    .toPng(node)
    .then((dataUrl) => {
        saveAs(dataUrl, `${file_name}.png`);

    })
    .catch(function (error) {
        console.error('oops, something went wrong!', error);
    });
}